import {
  createAsyncThunk,
  createEntityAdapter,
  createSlice,
  Dictionary,
  EntityId,
  EntityState,
} from '@reduxjs/toolkit';
import { apiClient } from 'api';
import {
  GetOrderItemList,
} from 'api/orderItem';
import {
  OrderItem,
} from 'constants/interface';
import { RootState } from 'state';

const orderItemEntityAdapter = createEntityAdapter<OrderItem>();

export interface OrderItemsState extends EntityState<OrderItem> {
  isLoading: boolean
  remoteTotal: number
}

export const initialState: OrderItemsState = orderItemEntityAdapter.getInitialState({
  isLoading: false,
  remoteTotal: 0,
});

export const getOrderItemAction = createAsyncThunk(
  'orderItems/get',
  async (payload: {
    orderItemId: string,
  }) => {
    const { orderItemId } = payload;
    const response = await apiClient.orderItem.getOrderItem(orderItemId);

    return response;
  },
);

export const getOrderItemListAction = createAsyncThunk(
  'orderItems/list',
  async (payload: GetOrderItemList) => {
    const response = await apiClient
      .orderItem
      .getOrderItemList(payload);

    return response;
  },
);

export const orderItemsSlice = createSlice({
  name: 'orderItems',
  initialState,
  reducers: {
    cleanOrderItemsAction: orderItemEntityAdapter.removeAll,
  },
  extraReducers: (builder) => {
    // List
    builder.addCase(getOrderItemListAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrderItemListAction.fulfilled, (state, action) => {
      orderItemEntityAdapter.removeAll(state);
      orderItemEntityAdapter.addMany(state, action.payload.data);
      state.remoteTotal = action.payload.pagination.total;
      state.isLoading = false;
    });
    builder.addCase(getOrderItemListAction.rejected, (state) => {
      state.isLoading = false;
    });

    // Single
    builder.addCase(getOrderItemAction.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrderItemAction.fulfilled, (state, action) => {
      // orderItemEntityAdapter.removeAll(state);
      // orderItemEntityAdapter.addMany(state, action.payload.data);
      orderItemEntityAdapter.removeOne(state, action.payload.id);
      orderItemEntityAdapter.addOne(state, action.payload);
      state.isLoading = false;
    });
    builder.addCase(getOrderItemAction.rejected, (state) => {
      state.isLoading = false;
    });
  },
});

export const {
  cleanOrderItemsAction,
} = orderItemsSlice.actions;

// Selectors

export const isLoadingOrderItemsSelector = (state: RootState):
  boolean => state.orderItems.isLoading;

export const orderItemsEntitiesSelector = (state: RootState):
  Dictionary<OrderItem> => state.orderItems.entities;

export const orderItemsIdsSelector = (state: RootState):
  EntityId[] => state.orderItems.ids;

export const remoteTotalSelector = (state: RootState):
  number => state.orderItems.remoteTotal;
